import AdminApi from '@src/lib/adminApi';
import { getProfileApi, loginApi } from './auth';
import {
  createClientsApi,
  deleteClientByUserIdApi,
  getClientByUserIdApi,
  getClientsListApi,
} from './clients';
import {
  addManagerToCompanyApi,
  createCompanyApi,
  deleteCompanyByCompanyIdApi,
  deleteManagerByUserIdApi,
  getCompaniesListApi,
  getCompanyByCompanyIdApi,
  getCompanyByUserIdApi,
  getManagerListByCompanyIdApi,
  updateCompanyByCompanyIdApi,
  updateManagerRoleByIdsApi,
} from './companies';
import {
  approveInfluencersApi,
  createInfluencersApi,
  getInfluencerListApi,
  updateInfluencerByCharisIdApi,
} from './influencers';
import { getPaymentByIdApi } from './payment';
import {
  getProjectByIdApi,
  getProjectsListApi,
  updateProjectDataByIdApi,
} from './projects';
import {
  authorizeAdminByUserIdApi,
  createUserApi,
  deleteUserByIdApi,
  getCompanyListByUserIdApi,
  getUserByIdApi,
  getUserListApi,
  updateUserByIdApi,
} from './users';

const oliveApi = new AdminApi({
  prefix: 'olive',
  baseUrl: process.env.REACT_APP_API_HOST,
  formatter: (response) => response.data,
});

export {
  oliveApi,
  loginApi,
  getProfileApi,
  getUserListApi,
  createUserApi,
  getUserByIdApi,
  updateUserByIdApi,
  deleteUserByIdApi,
  getCompanyListByUserIdApi,
  authorizeAdminByUserIdApi,
  createClientsApi,
  getClientsListApi,
  getClientByUserIdApi,
  deleteClientByUserIdApi,
  createCompanyApi,
  getCompaniesListApi,
  addManagerToCompanyApi,
  getManagerListByCompanyIdApi,
  updateManagerRoleByIdsApi,
  deleteManagerByUserIdApi,
  getCompanyByUserIdApi,
  getCompanyByCompanyIdApi,
  updateCompanyByCompanyIdApi,
  deleteCompanyByCompanyIdApi,
  getProjectsListApi,
  getProjectByIdApi,
  updateProjectDataByIdApi,
  createInfluencersApi,
  getInfluencerListApi,
  updateInfluencerByCharisIdApi,
  approveInfluencersApi,
  getPaymentByIdApi,
};
